import { axiosInstance } from 'api/apiConfig'
import { useMutation, useQuery } from 'react-query'
import { objectToQueryString } from 'utils/object-to-query-string'

//고객만족도 현황관리 조회
const custSfdgPsntList = async (params) => {
  const { data } = await axiosInstance.get(`/api/mymen/storecircum/v1.0/custSfdgPsntMng${objectToQueryString(params)}`)
  return data
}

export const useCustSfdgPsntList = (params, isInit) => {
  return useQuery(['custSfdgPsntList'], () => custSfdgPsntList(params), {
    enabled: isInit,
  })
}

//고객만족도 직접입력 항목 조회
const custSfdgPsntInput = async (params) => {
  const { data } = await axiosInstance.get(`/api/mymen/storecircum/v1.0/custSfdgPsntMng/input${objectToQueryString(params)}`)
  return data
}

export const useCustSfdgPsntInput = (params, isInit) => {
  return useQuery(['custSfdgPsntInput'], () => custSfdgPsntInput(params), {
    enabled: isInit,
  })
}


//고객만족도 현황관리 저장
const custSfdgPsntRegist = async (params) => {
  const { data } = await axiosInstance.post('/api/mymen/storecircum/v1.0/custSfdgPsntMng/input', params)
  return data
}

export const useCustSfdgPsntRegist = ({ successHandler, errorHandler }) => {
  return useMutation((params) => custSfdgPsntRegist(params), {
    onSuccess: ({ data }) => {
      successHandler(data)
    },
    onError: (error) => {
      errorHandler(error)
    },
  })
}